import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ICON_NAMES, resolveIcon } from "@/cms/icons";

/** Dropdown over the fixed icon palette (src/cms/icons.js) — content is
 * plain Firestore data, so an icon field can only ever be one of these
 * named options, never an arbitrary component. */
export default function IconPicker({ value, onChange }) {
  return (
    <Select value={value || undefined} onValueChange={onChange}>
      {/* SelectValue re-renders the matched SelectItem's children (icon +
          name) when closed, so it doesn't need its own icon drawn here too
          — that would show the icon twice. */}
      <SelectTrigger className="h-11 rounded-xl border-gray-200 bg-gray-50">
        <SelectValue placeholder="Choose an icon" />
      </SelectTrigger>
      <SelectContent>
        {ICON_NAMES.map((name) => {
          const OptionIcon = resolveIcon(name);
          return (
            <SelectItem key={name} value={name}>
              <div className="flex items-center gap-2">
                <OptionIcon className="h-4 w-4" />
                {name}
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
